const chartColorPallets = [
  ['#FFCE5A', '#CED980', '#8BCD6D', '#20AA94', '#107793', '#003967'],
  ['#23758F', '#9787BA', '#62B8D0', '#E07008', '#E9CD2F', '#A72D1A'],
  ['#670981', '#DB245A', '#D68308', '#AD0072', '#AEAD17', '#EAE34B'],
  ['#18CCC0', '#249BDD', '#325F9F', '#D5C8F2', '#AEAD17', '#CDE980'],
];

export default chartColorPallets;
